import React, { Component } from 'react';

import ConsultantForm from './components/ConsultantForm/ConsultantForm';
import './ConsultantManagementPage.scss';

export class ConsultantManagementPage extends Component {
    render() {
        const { match } = this.props;
        const isCreateNewConsultant = match.params.consultantId === undefined;

        return (
            <div className="ConsultantManagementPage">
	            <h2>{isCreateNewConsultant ? 'Create New Consultant' : 'Edit Consultant'}</h2>
	            <ConsultantForm/>
            </div>
        );
    }
}

export default ConsultantManagementPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ConsultantManagementPage/ConsultantManagementPage.js